import React from 'react'
import SideMenu, {menuItemsGitlab} from '../../components/SideMenuGitlab/SideMenuGitlab'


import { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import '../DocumentationTeamHealth/DocTeamHealth.css'

const GettingStarted = () => {
    const [inactive, setInactive] = useState(false);

    return (
      <>
      			
<div style={{marginTop : "30px"}} >
           <SideMenu
            onCollapse={(inactive) => {
              //console.log(inactive);
              setInactive(inactive);
            }}
          />

          <div className={`container ${inactive ? "inactive" : ""}`}>

            {/* improvememt, not recorded in video, its just looping through menuItemsGitlab
            instead of hard coding all the routes */}
            {menuItemsGitlab.map((menu, index) => (
              <>
                <Route key={menu.name} exact={menu.exact} path={menu.to}>
               

                  <p>Gitlab monitoring gadget documentation</p>                     
                  <h1 >Getting started</h1>

                  <h3>1.Installing</h3>

                  <ol>                    
                    <li >Log into your Confluence instance as an admin.</li>
                    <li>Click the admin dropdown and choose Apps. </li>
                    <li>Locate Gitlab monitoring Gadget.</li>
                    <li>Click Free trial to download and install your app.</li>
                    <li>Click Close in the Installed and ready to go dialog.</li>                   
                  </ol>     
                                 


                  <h3>2.Add Gitlab monitoring gadget to Jira dashboard</h3>

                  <ul>
                    <li>Find Gitlab monitoring gadget in the Gadgets Directory and click "Add gadget"</li>
                  </ul>

                  <h3>3.Configure Gitlab monitoring options</h3>
                  <p>there are only three options are required:</p>
                  <ul>
                
                    <li style={{marginLeft:"6%"}}>Your gitlab project link or ID</li>
                    <p>You must specify the gitlab project you want to check </p>

                    <li style={{marginLeft:"6%"}}>Your gitlab API token</li>
                    <p>You can generate your Gitlab API token by following those simple steps :</p>
                    <a href='https://docs.gitlab.com/ee/user/profile/personal_access_tokens.html' target={"_blank"}>access to lien</a>

                    <li style={{marginLeft:"6%"}}>Number of versions</li>
                    <p>You must specify the number of versions you want to check </p>
                    <img style={{ margin:"10px"}} src="./assets/gitlabmonitoring1.png" alt="img1" width="90%" height="90%"/>  

                    <p> Click Display commits once project link/ID and API Token are specified. </p>               

                    

                    
                   

                  </ul>  
                  {/*   
                  <button style={{
                    backgroundColor: "green",
                    border: "none",
                    color: "white",
                    padding: "15px 32px",
                    textAlign: "center",
                    textDecoration: "none",
                    display: "inline-block",
                    fontSize: "16px",
                    margin: "4px 2px",
                    cursor: "pointer",
                    borderRadius: "10px",
                  }}>Next</button>
                 */}

                 
                 
  
  
                </Route>
                {menu.subMenus && menu.subMenus.length > 0
                  ? menu.subMenus.map((subMenu, i) => (
                      <Route key={subMenu.name} path={subMenu.to}>
                        <h1>{subMenu.name}</h1>
                      </Route>
                    ))
                  : null}
              </>
            ))}
             
  
            {/* <Switch>
              <Route exact path={"/"}>
                <Dashboard />
              </Route>
              <Route exact path={"/content"}>
                <Content />
              </Route>
              <Route path={"/content/courses"}>
                <Courses />
              </Route>
              <Route path={"/content/videos"}>
                <Videos />
              </Route>
              <Route path={"/design"}>
                <Design />
              </Route>
              <Route exact path={"/content-2"}>
                <Content2 />
              </Route>
              <Route path={"/content-2/courses"}>
                <Courses2 />
              </Route>
              <Route path={"/content-2/videos"}>
                <Videos2 />
              </Route>
              <Route path={"/design-2"}>
                <Design2 />
              </Route>
            </Switch> */}
           
          </div>
</div>
      </>
      
    )
  }
  

export default GettingStarted
